import { authApi, coreApi } from "./apiInstances";
import config from "../config";

class AuthApi {
  static Login = (data) => {
    return authApi.post(config.django.apiEndpoints.login, data);
  };

  static Logout = () => {
    return authApi.post(config.django.apiEndpoints.logout, {});
  };

  static SwitchService = (serviceId) => {
    return authApi.post(config.django.apiEndpoints.switchService, { service_id: serviceId });
  };

  static Me = () => {
    return coreApi.get(config.django.apiEndpoints.me);
  };
}

export default AuthApi;
